module.exports = __webpack_public_path__ + "img/6h.12cfdc20.png";